import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { TtIconLibrary } from '@23/ui-wc/dist/components/tt-icon-library.js'

import { useWebinarColors } from '../../../sharedLegacy/hooks/useWebinarColors'
import {
  WebinarPanelComponent,
  WebinarSidebarSeparator,
} from '../../../sharedLegacy/features/WebinarSidebarFeature/components'
import ButtonComponent from '../../../sharedLegacy/components/ButtonComponent/ButtonComponent'

import './JoinToSpeakInfoPanel.scss'

type Props = {
  onDismiss: () => void
  onAccept: () => void
}

const JoinToSpeakInfoPanel = ({ onDismiss, onAccept }: Props) => {
  const webinarColors = useWebinarColors()
  const [svg, setSvg] = useState('')

  useEffect(() => {
    // don't love this solution, but didn't want to refactor the whole thing
    // @ts-expect-error — non-declared function
    TtIconLibrary.getIconSvg('one', 'check').then((iconSvg) =>
      setSvg(
        encodeURIComponent(
          iconSvg.replace('currentColor', webinarColors.tabs.contrast)
        )
      )
    )
  }, [webinarColors.tabs.contrast])

  return (
    <>
      <WebinarPanelComponent className="join-to-speak-info-panel">
        <ul style={{ '--check-icon-url': `url(data:image/svg+xml,${svg})` }}>
          <li>
            <FormattedMessage defaultMessage="Ask questions and chat with the speakers live on video." />
          </li>
          <li>
            <FormattedMessage defaultMessage="In the next step, give your browser access to your camera and microphone." />
          </li>
          <li>
            <FormattedMessage defaultMessage="You can then request access to get on camera." />
          </li>
        </ul>

        <div className="buttons">
          <ButtonComponent
            className="cancel-button"
            type="button"
            color="themed"
            style={{
              backgroundColor: webinarColors.tabs.contrast.transparent('5%'),
              color: webinarColors.tabs.contrast.color,
            }}
            round
            ariaLabel=""
            onClick={onDismiss}
          >
            <FormattedMessage defaultMessage="Cancel" />
          </ButtonComponent>
          <ButtonComponent
            className="accept-button"
            type="button"
            color="themed"
            style={{
              backgroundColor: webinarColors.accent.color,
              color: webinarColors.accent.contrast.color,
            }}
            round
            ariaLabel=""
            onClick={onAccept}
          >
            <FormattedMessage defaultMessage="Give permissions" />
          </ButtonComponent>
        </div>
      </WebinarPanelComponent>
      <WebinarSidebarSeparator />
    </>
  )
}

export { JoinToSpeakInfoPanel }
